import { useState } from "react";
import GprofileHeader from "./GprofileHeader";
import GprofileHero from "./GprofileHero";
import GprofileActions from "./GprofileActions";
import GprofileAbout from "./GprofileAbout";
import GprofileInfo from "./GprofileInfo";
import GprofileLookingFor from "./GprofileLookingFor";
import GprofileGallery from "./GprofileGallery";
import GprofileInteractionHistory from "./GprofileInteractionHistory";
import GprofileLocationRadius from "./GprofileLocationRadius";
import RightSideMenu from "@/components/navigation/RightSideMenu";
import { getDisplayName } from "@/utils/gprofileUtils";
import { useAuth } from "@/hooks/useAuth";
import { UserProfile } from "@/types/gprofile";

interface GprofileContentProps {
  profile: UserProfile;
  onBack: () => void;
}

const GprofileContent = ({ profile, onBack }: GprofileContentProps) => {
  const { user } = useAuth();
  const [currentPhotoIndex, setCurrentPhotoIndex] = useState(0);
  const displayName = getDisplayName(profile);
  const isOwnProfile = user?.id === profile.user_id;

  console.log('✅ Rendering profile for:', displayName);

  return (
    <div className="min-h-screen bg-carbon text-ice-white relative overflow-hidden">
      <RightSideMenu />
      
      {/* Chapter 1: Top Navigation */}
      <GprofileHeader 
        displayName={displayName}
        onBack={onBack}
        userId={profile.user_id}
      />

      {/* Main Content */}
      <div className="pb-4">
        {/* Chapter 4: Profile Picture & Gallery + Chapter 3: Distance/Status */}
        <GprofileHero
          profile={profile}
          currentPhotoIndex={currentPhotoIndex}
          onPhotoChange={setCurrentPhotoIndex}
        />

        {/* Chapter 5: Action Buttons */}
        <GprofileActions
          userId={profile.user_id}
          displayName={displayName}
        />

        {/* Chapter 6: About Me Section */}
        {profile.bio && (
          <GprofileAbout bio={profile.bio} />
        )}

        {/* Chapter 7: Profile Info Fields */}
        <GprofileInfo profile={profile} isOwnProfile={isOwnProfile} />

        {/* Chapter 8: Looking For */}
        {profile.looking_for && profile.looking_for.length > 0 && (
          <GprofileLookingFor lookingFor={profile.looking_for} />
        )}

        {/* Chapter 9: Public Photos Gallery */}
        {profile.photo_urls && profile.photo_urls.length > 1 && (
          <GprofileGallery
            photos={profile.photo_urls.slice(1)}
            displayName={displayName}
          />
        )}

        {/* Chapter 10: Interaction History */}
        <GprofileInteractionHistory
          userId={profile.user_id}
          displayName={displayName}
        />

        {/* GPS Radius Indicator */}
        <GprofileLocationRadius
          precisionMeters={profile.location_precision_meters}
          showToOthers={profile.show_location_precision}
          isOwnProfile={isOwnProfile}
        />
      </div>
    </div>
  );
};

export default GprofileContent;
